import hash from 'react-router-history';
import swal from 'sweetalert2';

import * as a from '../actionsTypes/actionTypes';
import laris from '../api/laris';
import { createSuccessNotification, sendErroRequest } from '../utils/Notification';

const { hashHistory } = hash;

export const setInstrucoesBancarias = (response) => ({
  type: a.IBC_GET_INSTRUCOES_BANCARIAS,
  payload: response,
});

export const processandoInstrucaoBancaria = (bool) => ({
  type: a.IBC_PROCESSANDO_INSTRUCAO_BANCARIA,
  payload: bool,
});

export const setInstrucaoBancariaById = (data) => ({
  type: a.IBC_GET_INSTRUCOES_BANCARIAS_BY_ID,
  payload: data,
});

const setEstadoInicial = () => ({ type: a.IBC_SET_ESTADO_INICIAL });

export const getInstrucoesBancarias = () => async (dispatch) => {
  try {
    dispatch(processandoInstrucaoBancaria(true));

    const { data } = await laris.get(`/instrucoes-bancarias`);

    dispatch(setInstrucoesBancarias(data), processandoInstrucaoBancaria(false));
  } catch (err) {
    dispatch(processandoInstrucaoBancaria(false));
    sendErroRequest(err, 'Ocorreu um erro ao buscar as Instruçãs Bancaárias!');
  }
};

export const getInstrucaoBancariaById = (id) => async (dispatch) => {
  try {
    dispatch(processandoInstrucaoBancaria(true));
    const { data } = await laris.get(`/instrucoes-bancarias/${id}`);
    dispatch(setInstrucaoBancariaById(data));
    dispatch(processandoInstrucaoBancaria(false));
  } catch (error) {
    dispatch(processandoInstrucaoBancaria(false));
    sendErroRequest(error, 'Ocorreu um erro ao buscar a Instrução Bancária selecionada!');
  }
};

export const deleteInstrucaoBancaria = (id) => async (dispatch) => {
  try {
    const res = await swal.fire({
      title: 'Confirmar deleção!',
      text: 'Você tem certeza que deseja deletar esse item?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Realmente deseja deletar?',
      cancelButtonText: 'Cancelar',
    });

    if (res.value) {
      await laris.delete(`/instrucoes-bancarias/${id}`);

      dispatch(getInstrucoesBancarias('', 0));
      createSuccessNotification('Instrução Bancária excluído com sucesso!');
    }
  } catch (error) {
    sendErroRequest(error, 'Ocorreu um erro ao excluir a Instrução Bancária selecionada!');
  }
};

export const putInstrucaoBancaria = (values) => async (dispatch) => {
  try {
    dispatch(processandoInstrucaoBancaria(true));

    await laris.put(`/instrucoes-bancarias`, values);
    dispatch(processandoInstrucaoBancaria(false));
    hashHistory.push('/instrucoes-bancarias');
    createSuccessNotification('Instrução Bancária alterada com sucesso!');
  } catch (err) {
    dispatch(processandoInstrucaoBancaria(false));
    sendErroRequest(err, 'Ocorreu um erro ao alterar a Instrução Bancária!');
  }
};

export const postInstrucaoBancaria = (values) => async (dispatch) => {
  try {
    dispatch(processandoInstrucaoBancaria(true));
    await laris.post(`/instrucoes-bancarias`, values);
    dispatch(processandoInstrucaoBancaria(false));
    createSuccessNotification('Instrução Bancária cadastrada com sucesso');
    hashHistory.push('/instrucoes-bancarias');
  } catch (err) {
    dispatch(processandoInstrucaoBancaria(false));
    sendErroRequest(err, 'Ocorreu um erro ao cadastrar a Instrução Bancária!');
  }
};
